import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { IonIcon, IonImg, IonList, IonLoading } from '@ionic/react';
import { thumbsUpSharp, thumbsDownSharp } from 'ionicons/icons';
import { PageLayout } from 'containers/layout';
import ReceiptActions, { ReceiptSelectors } from 'redux/ReceiptRedux';
import ReceiptDetail from 'containers/receipts/ReceiptDetail';
import { AppSelectors } from 'redux/AppRedux';
import { VenueLogo } from 'components/venue';

function PublicReceipt() {
  const params = useParams();
  const dispatch = useDispatch();
  const currentReceipt = useSelector(ReceiptSelectors.selectCurrentReceipt);
  const loading = useSelector(ReceiptSelectors.selectCurrentReceiptLoading);
  const venueDetail = useSelector(
    AppSelectors.selectVenueDetailById(currentReceipt?.venueId)
  );

  useEffect(() => {
    if (params.receiptId) {
      dispatch(ReceiptActions.loadCurrentReceipt(params.receiptId));
    }
  }, [params.receiptId]);

  const settings = venueDetail?.settings?.vemospay || {
    receipt_message: '',
    loyalty_enabled: false,
    feedback_links_enabled: false,
    thumbs_up_url: '',
    thumbs_down_url: '',
  };

  return (
    <PageLayout hideHeader>
      <IonLoading isOpen={loading} message="Loading..." />
      {currentReceipt && (
        <>
          <IonList className="receipt-white-block">
            <div className="receipt-venue-logo">
              <VenueLogo logo={venueDetail?.logo} />
            </div>
            <div className="receipt-loyalty-text">
              {settings.loyalty_enabled && (
                <p>
                  Sign up for our rewards program and exclusive offers with
                  Vēmos Pay
                </p>
              )}
              <a
                href="http://qrco.de/bbz6BG"
                target="_blank"
                rel="noopener noreferrer"
              >
                vemospay.com
              </a>
            </div>
          </IonList>
          <ReceiptDetail receipt={currentReceipt} />
          <IonList>
            {settings.receipt_message && (
              <div className="receipt-message">{settings.receipt_message}</div>
            )}
            {settings.feedback_links_enabled && (
              <div className="receipt-feedbacks">
                <h4>How was your experience?</h4>
                <p>We'd love to hear your feedback</p>
                <div className="receipt-feedback__links">
                  <a
                    href={settings.thumbs_up_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IonIcon icon={thumbsUpSharp} size="large" />
                  </a>
                  <a
                    href={settings.thumbs_down_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IonIcon icon={thumbsDownSharp} size="large" />
                  </a>
                </div>
              </div>
            )}
          </IonList>
          <IonList className="receipt-white-block">
            <div className="receipt-feedbacks">
              <h4>Download the Vēmos Pay app</h4>
              <p>
                Pay your tab and earn rewards across your favorite restaurants &
                bars.
              </p>

              <div className="receipt-download-links">
                <a
                  href="https://apps.apple.com/us/app/id1521512947"
                  alt="apple appstore"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="store-link appstore" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.vemos.vemospay"
                  alt="google playstore"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="store-link playstore" />
                </a>
              </div>
            </div>
          </IonList>
          <IonList>
            <div className="receipt-powered-by">
              <div className="receipt-powered-by-img">
                <img src="/assets/vemospay-white-logo.png" alt="vemospay" />
              </div>
              <div>Powered by Vēmos</div>
            </div>
          </IonList>
        </>
      )}
    </PageLayout>
  );
}

export default PublicReceipt;
